// extracted by mini-css-extract-plugin
export default {"base":"Login_base__SXwax","bigHeader":"Login_bigHeader__lyDWg","disclaimer":"Login_disclaimer__61TB-"};